import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { TextArea } from '@/components/ui/text-area';

import { CollapsableCard } from '../collapsable-card';
import { FurnitureSettings } from './furniture-settings';
import { LandscapeSettings } from './landscape-settings';
import { ObjectsSettings } from './objects-settings';

export const MagicStyle = () => {
  const { t } = useTranslation();

  return (
    <CollapsableCard title={t('style')}>
      <div className="flex flex-col gap-2">
        <LandscapeSettings />
        <FurnitureSettings />
        <ObjectsSettings />
        <span className="text-center text-[10px] leading-[24px]">{t('or')}</span>
        <TextArea
          wrapperClassName="overflow-hidden gap-0"
          className="!h-[150px] py-2 pl-2 pr-2"
          placeholder={`${t('type')}...`}
          autoFocus
        />
        <div className="flex w-full gap-2">
          <Button className="h-[38px] flex-1">{t('render')}</Button>
          <Button className="h-[38px] flex-1 border border-solid border-primary-light bg-white text-primary-light">
            {t('reset')}
          </Button>
        </div>
      </div>
    </CollapsableCard>
  );
};
